<app-admin-controls>
    <mat-card class="mat-elevation-z0">
        <mat-card-title class="header">
            <h5 appLocalizationPopupDirective localizationCode="AdminControlsPositions">{{ 'AdminControlsPositions' | translate: {Default: "Admin Controls: Positions"} }}</h5>
        </mat-card-title>

        <mat-card-content>
            <div class="page-description-section">
                This will create {{numberOfPositions}} random position(s)
            </div>

            <mat-form-field appearance="fill">
                <mat-label>
                    Number Of Positions
                </mat-label>
        
                <input matInput type="number" [(ngModel)]="numberOfPositions">
            </mat-form-field>

            <button mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="createPositions()">Create</button>
        </mat-card-content>
    </mat-card>
</app-admin-controls>